import * as types from './mutation-types'

export default {
  [types.SET_SETTINGS] (state, payload) {
    if (payload) {
      state.settings = { ...state.settings, ...payload }
    }
  }
}
